/** The highest Solana transaction version this SDK reads back (SIMD-0385 v1). */
export const SOLANA_MAX_SUPPORTED_TRANSACTION_VERSION = 1;
/**
 * getTransaction that survives a SIMD-0385 v1 response. @solana/web3.js 1.98.x
 * validates `version` against `0 | 'legacy'` and THROWS on 1 even when the request
 * raised the ceiling, so a real `Connection` (which exposes `rpcEndpoint`) is read
 * as raw JSON-RPC instead. An injected double without an endpoint goes through its
 * own `getTransaction` with the ceiling raised. Returns the RPC `result` (null when
 * the signature is unknown); RPC and transport failures throw so callers keep
 * treating a failed lookup as inconclusive rather than as absence.
 */
export async function getTransactionJson(rpc, signature, commitment = 'confirmed') {
    var _a;
    const endpoint = typeof (rpc === null || rpc === void 0 ? void 0 : rpc.rpcEndpoint) === 'string' ? rpc.rpcEndpoint.trim() : '';
    if (!endpoint) {
        return rpc.getTransaction(signature, {
            maxSupportedTransactionVersion: SOLANA_MAX_SUPPORTED_TRANSACTION_VERSION,
            commitment,
        });
    }
    const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
            jsonrpc: '2.0',
            id: 1,
            method: 'getTransaction',
            params: [signature, {
                    commitment,
                    encoding: 'json',
                    maxSupportedTransactionVersion: SOLANA_MAX_SUPPORTED_TRANSACTION_VERSION,
                }],
        }),
    });
    if (!response.ok)
        throw new Error(`getTransaction http ${response.status}`);
    const body = await response.json();
    if (body === null || body === void 0 ? void 0 : body.error)
        throw new Error(`getTransaction rpc error ${body.error.code}: ${body.error.message}`);
    return (_a = body === null || body === void 0 ? void 0 : body.result) !== null && _a !== void 0 ? _a : null;
}
